import { platform } from '@/utils/platform';

/**
 * Check if native Apple Auth is available via @capgo/capacitor-social-login.
 */
export function isNativeAppleAuthAvailable(): boolean {
  return platform.isNative && platform.isIOS && platform.isPluginAvailable('SocialLogin');
}

export async function initNativeAppleAuth() {
  if (!isNativeAppleAuthAvailable()) return;

  try {
    const { SocialLogin } = await import('@capgo/capacitor-social-login');
    await SocialLogin.initialize({
      apple: {
        clientId: 'com.brainsway.report',
      },
    });
    console.log('[AppleAuth] Initialized via @capgo/capacitor-social-login');
  } catch (err) {
    console.warn('[AppleAuth] Init failed:', err);
  }
}

export interface AppleSignInResult {
  identityToken: string;
  user?: {
    name?: {
      firstName?: string;
      lastName?: string;
    };
  };
}

export async function nativeAppleSignIn(): Promise<AppleSignInResult> {
  const { SocialLogin } = await import('@capgo/capacitor-social-login');
  const res = await SocialLogin.login({
    provider: 'apple',
    options: {
      scopes: ['email', 'name'],
    },
  });

  const result = res.result as any;
  const idToken = result.idToken || result.identityToken;
  if (!idToken) {
    throw new Error('No identity token received from Apple Sign-In');
  }

  return {
    identityToken: idToken,
    user: result.user,
  };
}
